import * as commercialUsers from './users';

const reducers = {
  ...commercialUsers,
};

export default reducers;
